import CDialogInput from "components/CDialogInput";
import { useContextListOpenFile } from "context/listopenfile.context";
import React from "react";
import { useTranslation } from "react-i18next";

interface FolderDialogHandleProps extends Props {
    handleCloseDialog: () => void;
}

export default function FolderDialogHandle({
    handleCloseDialog,
}: FolderDialogHandleProps): JSX.Element {
    const { callActions } = useContextListOpenFile();
    const { t } = useTranslation();

    function handleYesDialog(nameFolder: string) {
        callActions({ type: "add-folder", val: nameFolder });
    }

    return (
        <CDialogInput
            title={t("dashboard.dialogs.addFolderTitle")}
            description={t("dashboard.dialogs.addFolderDescription")}
            arrText={[""]}
            loading={false}
            handleYesDialog={handleYesDialog}
            handleCloseDialog={handleCloseDialog}
        ></CDialogInput>
    );
}
